export default "__VITE_PUBLIC_ASSET__673b577e__"